"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getReadableIndex = void 0;
var getReadableIndex = function (index) { return index + 1; };
exports.getReadableIndex = getReadableIndex;
